import { PaymentMethods } from '~/types/payments';

export enum CompanyName {
  CityDrinks = 'citydrinks',
  Localee = 'localee',
  CircleK = 'circlek',
  Vilo = 'vilo',
  Jiffy = 'jiffy',
  Kids = 'ourkids',
  Okie = 'okie',
  Oskuhus = 'oskuhus',
  Heimkaup = 'heimkaup',
  Cerise = 'cerise',
}

export enum TimeFormat {
  'h12' = 'h12',
  'h24' = 'h24',
}

export type EnvVariables = {
  REACT_APP_MIDTRANS_KEY: string;
  REACT_APP_MIDTRANS_URL: string;
  REACT_APP_INTERCOM_ID: string;
  REACT_APP_API_ROOT: string;
  REACT_APP_TRACKING_MAP_API_URL: string;
  REACT_APP_CLOUDFLARE_IMAGE_RESIZE_DOMAIN: string;
  REACT_APP_CLOUDFLARE_IMAGE_RESIZE_ENABLED: string;
  REACT_APP_AWS_PAY_BASE_URL: string;
  REACT_APP_AWS_PAY_PHRASE: string;
  REACT_APP_AWS_PAY_RETURN_URL: string;
  REACT_APP_AWS_PAY_ACCESS_CODE: string;
  REACT_APP_MERCHANT_IDENTIFIER: string;
  REACT_APP_PREDEFINED_CAPTCHA_TOKEN: string;
  REACT_APP_STRIPE_API_KEY: string;
  REACT_APP_BI_API_KEY: string;
  REACT_APP_RECAPTCHA_ID: string;
};

export type GtmConfig = { auth: string; preview: string };

export type CompanyConfig = {
  id: string;
  lang: string;
  langs: string[];
  name: string;
  nameSecondary: string;
  currency: string;
  officialName: string;
  marketingEmail?: string;
  email: string;
  feedbackEmail?: string;
  phonePlaceholder: string;
  defaultPhoneCode?: string;
  phoneNumber?: string;
  address?: string;
  canonical: string;
  ageRestricted: number;
  timeZone: string;
  minimalOrderFeeThreshold: number;
  useGoogleApiForGeocoding?: boolean;
  countryCode?: string;
  defaultVolumeDisplay?: string;
  warehouse: {
    default: string;
    minimalOrderFeeWarehouseCodes: string[];
    location: GeoCoordinates;
  };
  map: {
    center: GeoCoordinates;
    zoom: number;
    markers?: {
      position: GeoCoordinates;
      label?: string;
    }[];
  };
  paymentMethods: PaymentMethods[];
  timeFormat: TimeFormat;
  links: {
    terms?: string;
    privacy?: string;
    cookie: string;
    deliveryZones: string;
    forRiders: string;
    affiliateProgram: string;
    blog?: string;
    legals?: {
      [key: string]: {
        label: string;
        link: string;
        blank?: boolean;
      };
    };
    whatsapp?: string;
    facebook?: string;
    instagram?: string;
    tiktok?: string;
    youtube?: string;
    linkedin?: string;
    twitter?: string;
    // [key: string]: string;
  };
  referral: {
    code: string;
    discount: string;
    minBasket: string;
    downloadAppLink: string;
  };
  points?: {
    value?: string;
    pointsPerUnit?: number;
    icon: 'coins' | 'jiffy-points';
  };
  appStoreUrl: {
    ios: string;
    android: string;
  };
  apis: {
    [api: string]: {
      token?: string | number;
      locale?: string;
      production?: GtmConfig | string;
      staging?: GtmConfig | string;
      test?: GtmConfig | string;
      development?: GtmConfig | string;
      gtmId?: string;
      url?: string;
      widgetId?: string;
    };
  };
  license: {
    name: string;
    numberPrinary: string;
    numberSecondary?: string;
  };
};
